import { render, staticRenderFns } from "./InboundSummary.vue?vue&type=template&id=bd425ec6"
import script from "./InboundSummary.vue?vue&type=script&lang=js"
export * from "./InboundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd425ec6')) {
      api.createRecord('bd425ec6', component.options)
    } else {
      api.reload('bd425ec6', component.options)
    }
    module.hot.accept("./InboundSummary.vue?vue&type=template&id=bd425ec6", function () {
      api.rerender('bd425ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inbound/InboundSummary.vue"
export default component.exports